import { render } from "./MobileLanguageSwitcher.vue?vue&type=template&id=4396cd53&bindings={\"expanded\":\"data\",\"otherLanguage\":\"options\",\"setActiveLanguage\":\"options\"}"
import script from "./MobileLanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./MobileLanguageSwitcher.vue?vue&type=script&lang=js"
script.render = render

export default script